const KeyboardService = {
  KEYS: {
    ESCAPE: 27,
  },
};

export default KeyboardService;
